/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publishbeforesharing2Inputs */

const en_publishbeforesharing2 = /** @type {(inputs: Publishbeforesharing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish this first before sharing`)
};

const de_publishbeforesharing2 = /** @type {(inputs: Publishbeforesharing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuerst veröffentlichen, bevor es geteilt werden kann`)
};

/**
* | output |
* | --- |
* | "Publish this first before sharing" |
*
* @param {Publishbeforesharing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const publishbeforesharing2 = /** @type {((inputs?: Publishbeforesharing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishbeforesharing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publishbeforesharing2(inputs)
	return de_publishbeforesharing2(inputs)
});
export { publishbeforesharing2 as "publishBeforeSharing" }